export default {
    name: 'Navigation',
    data() {
        return {
           
        }
    },
    methods: {
        NavigationRoute(uniqueKey, role, appDetails) {           
            if (role == 'admin') {
                if (uniqueKey == 'userCreation') {
                    this.$router.push({ name: 'UserCreation' });
                }
                else if (uniqueKey == 'adminHeaders') {
                    this.$router.push({ name: 'AdminHeader' });
                    localStorage.setItem('appId', appDetails.id);
                    localStorage.setItem('appKey', appDetails.appKey);                   
                }
                else if (uniqueKey == 'businessRules') {
                    this.$router.push({ name: 'ACRAdminBuisnessRule' });                 
                }
                else if (uniqueKey == 'BRC') {
                    this.$router.push({ name: 'ACRAdmin' });
                }
                else if (uniqueKey == 'MEMO') {
                    this.$router.push({ name: 'MEMOAdmin' });
                }
                else if (uniqueKey == 'acrReport') {
                    this.$router.push({ name: 'TransactionReports', params: { report: 'ACRReport' }});                 
                }
                else if (uniqueKey == 'citReport') {
                    this.$router.push({ name: 'TransactionReports', params: { report: 'CITReport' }});                 
                }
            }

        }
        
    }
}
